export default function(pointA, pointB) {
  return pointA[0] === pointB[0] && pointA[1] === pointB[1];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/topojson/node_modules/topojson-server/src/hash/point-equal.js
// module id = 21
// module chunks = 0 1